import { ReactNode } from 'react';
import { ContainerBase } from './containerBase';

interface Props {
	children: ReactNode;
	className?: string;
}

export const PageContainer: React.FC<Props> = ({ children, className }) => {
	return (
		<div className="relative overflow-hidden min-h-full">
			<ContainerBase>
				<div className={`max-w-[989px] m-auto ${className} `}>{children}</div>
			</ContainerBase>
		</div>
	);
};
